

import React from 'react'

const HomepageView = () => {
  return (
    <div></div>
  )
}

export default HomepageView